module.exports = __webpack_public_path__ + "img/3CA2721CD70A429A28DEF09573B20C85.3ca2721c.png";